import { generic as s } from "../constants";

const errorMessage = (element, part) =>
  console.warn(
    element +
      " cannot be converted into an object since " +
      part +
      "does not correspond to a child object in the chain."
  );

const parsePath = (namespace, element): any => {
  // If no namespace is provided just return the object based on element name
  if (!namespace || typeof namespace !== "string") {
    return s[element];
  }
  let result = s;
  const matches = namespace.split(/\./);
  matches.forEach(part => {
    if (typeof result === "object") {
      result = result[part];
    } else {
      return errorMessage(element, part);
    }
  });

  return result;
};

const getPropFromConstants = (namespace, element, prop) => {
  try {
    return parsePath(namespace, element)[prop];
  } catch (e) {
    console.log(
      `Error: Cannot find ${element}.${prop} or ${namespace}.${prop}`,
      e
    );
  }
};

export const getColor = (element: string, namespace?: string) => props => {
  return (
    props.theme[`${element}Color`] ||
    getPropFromConstants(namespace, element, "color")
  );
};

export const getLinkColor = (element: string, namespace?: string) => props => {
  return (
    props.theme[`${element}LinkColor`] ||
    getPropFromConstants(namespace, element, "linkColor")
  );
};

export const getHoverColor = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}Hover`] ||
    getPropFromConstants(namespace, element, "hover")
  );
};

export const getPressedColor = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}Pressed`] ||
    getPropFromConstants(namespace, element, "pressed")
  );
};

export const getDisabledColor = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}Disabled`] ||
    getPropFromConstants(namespace, element, "disabled")
  );
};

export const getSelectedColor = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}Selected`] ||
    getPropFromConstants(namespace, element, "selected")
  );
};

export const getActiveColor = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}Active`] ||
    getPropFromConstants(namespace, element, "active")
  );
};

export const getBackgroundColor = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}BackgroundColor`] ||
    getPropFromConstants(namespace, element, "backgroundColor")
  );
};

export const getBorder = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}Border`] ||
    getPropFromConstants(namespace, element, "border")
  );
};

export const getTextShadow = (element: string, namespace?: string) => ({
  theme
}) => {
  return (
    theme[`${element}TextShadow`] ||
    getPropFromConstants(namespace, element, "textShadow")
  );
};
